import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";

import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./screens/Home/Home";
import SearchMenu from "./screens/SearchMenu/SearchMenu";
import UserDashboard from "./screens/UserDashboard/UserDashboard";
import ViewRestaurant from "./screens/ViewRestaurant/ViewRestaurant";
import DummyPage from "./screens/DummyPage/DummyPage";
import PageNotFound from "./components/errorPages/PageNotFound";
import ForgetPassword from "./components/ForgetPassword/ForgetPassword";
import CoronaUpdates from "./components/CoronaUpdates/CoronaUpdates";

import store from "./redux/store";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions/TermsAndConditions";
import axios from "axios";

const App = (props) => {
  const webVisit = async () => {
    const WebVisit = sessionStorage.getItem("webVisitAPI");
    if (WebVisit !== "true") {
      try {
        const details = {
          code: "VISIT",
          description: "web visit",
          eventType: "web",
          eventName: "webVisit",
        };
        await axios.post("analytics/addEvent", details);
        sessionStorage.setItem("webVisitAPI", "true");
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    webVisit();
  }, []);

  return (
    <Provider store={store}>
      <Router>
        <Header />
        <main>
          <Switch>
            <Route path="/search" component={SearchMenu} />
            <Route path="/restaurant" component={ViewRestaurant} />
            <Route path="/restaurant/:id/:from" component={ViewRestaurant} />
            <Route path="/dashboard" component={UserDashboard} />
            <Route path="/dummy-page" component={DummyPage} />
            <Route path="/dummy-page1" component={DummyPage} />
            <Route path="/dummy-page2" component={DummyPage} />
            <Route path="/dummy-page3" component={DummyPage} />
            <Route path="/dummy-page4" component={DummyPage} />
            <Route path="/dummy-page5" component={DummyPage} />
            <Route path="/dummy-page6" component={DummyPage} />
            <Route path="/dummy-page7" component={DummyPage} />
            <Route path="/dummy-page8" component={DummyPage} />
            <Route path="/dummy-page9" component={DummyPage} />
            <Route path="/dummy-page10" component={DummyPage} />
            <Route path="/privacy-policy" component={PrivacyPolicy} />
            <Route
              path="/terms-and-conditions"
              component={TermsAndConditions}
            />
            <Route path="/coronaUpdates" component={CoronaUpdates} />
            <Route
              path="/forget-password"
              exact
              component={ForgetPassword}
            ></Route>
            <Route path="/" component={Home} exact />
            <Route component={PageNotFound}></Route>
          </Switch>
        </main>
        <Footer />
      </Router>
    </Provider>
  );
};

export default App;
